<div>
	<table mat-table class="expandable-table" aria-label="table" matSort [dataSource]="dataSource" multiTemplateDataRows>
		<ng-container [matColumnDef]="COLUMN_SELECT">
			<th mat-header-cell *matHeaderCellDef>
				<mat-checkbox
					id="codelist-checkbox-select-all-rows"
					(change)="onMasterToggle()"
					[checked]="hasSelectedRows() && isAllSelected()"
					[indeterminate]="hasSelectedRows() && !isAllSelected()"
					matTooltip="{{ 'i18n.tooltip.checkbox_all' | translate }}"
				>
				</mat-checkbox>
			</th>
			<td mat-cell *matCellDef="let row">
				<mat-checkbox
					(click)="$event.stopPropagation()"
					(change)="onToggleSelection(row)"
					[checked]="isRowSelected(row)"
					matTooltip="{{ 'i18n.tooltip.checkbox_single' | translate }}"
				>
				</mat-checkbox>
			</td>
		</ng-container>

		<ng-container [matColumnDef]="COLUMN_ACTIONS">
			<th mat-header-cell *matHeaderCellDef>
				<div class="action-wrapper">
					<div class="action-button">
						@if (canCreateCodeValues()) {
							<button
								id="codelist-remove-selected-rows"
								obButton="secondary"
								mat-icon-button
								matTooltip="{{ 'i18n.tooltip.delete_selected' | translate }}"
								(click)="onRemoveSelectedRows()"
								[disabled]="hasSelectedRows() === false"
							>
								<mat-icon svgIcon="delete" class="ob-icon"></mat-icon>
							</button>
						}
					</div>
					<div class="action-button">
						@if (canCreateCodeValues()) {
							<button
								id="codelist-add-row"
								obButton="secondary"
								mat-icon-button
								(click)="addRow()"
								[disabled]="!canAdd()"
								matTooltip="{{ 'i18n.tooltip.addrow' | translate }}"
							>
								<mat-icon svgIcon="plus" class="ob-icon"></mat-icon>
							</button>
						}
					</div>
				</div>
			</th>
			<td mat-cell *matCellDef="let element; let row">
				<div class="action-wrapper">
					<div class="action-button">
						<button
							id="codelist-edit-row-{{ onFindIndex(row) }}"
							obButton="secondary"
							mat-icon-button
							(click)="editRow(element)"
							[disabled]="hasSelectedRows()"
							matTooltip="{{ 'i18n.tooltip.edit' | translate }}"
						>
							<mat-icon svgIcon="pencil" class="ob-icon"></mat-icon>
						</button>
					</div>
					<div class="action-button">
						<button
							id="codelist-remove-row-{{ onFindIndex(row) }}"
							obButton="secondary"
							mat-icon-button
							(click)="removeRow(onFindIndex(row))"
							[disabled]="hasSelectedRows()"
							matTooltip="{{ 'i18n.button.remove.tooltip' | translate }}"
						>
							<mat-icon svgIcon="delete" class="ob-icon"></mat-icon>
						</button>
					</div>
				</div>
			</td>
		</ng-container>

		<ng-container [matColumnDef]="COLUMN_VALUE">
			<th mat-header-cell mat-sort-header *matHeaderCellDef>
				{{ "i18n.property.code_value" | translate }}
			</th>
			<td mat-cell *matCellDef="let element" [title]="COLUMN_VALUE">
				{{ element?.value }}
			</td>
		</ng-container>

		<ng-container [matColumnDef]="COLUMN_PARENTCODE">
			<th mat-header-cell mat-sort-header *matHeaderCellDef>
				{{ "i18n.property.parent_code" | translate }}
			</th>
			<td mat-cell *matCellDef="let element">
				{{ element?.parentCode }}
			</td>
		</ng-container>

		@for (lang of contentLanguages; track lang) {
			<ng-container [matColumnDef]="lang">
				<th mat-header-cell mat-sort-header *matHeaderCellDef>
					{{ "i18n.property.codename_" + lang | translate }}
				</th>
				<td mat-cell *matCellDef="let element">
					{{ getTranslatedName(element.name, lang) }}
				</td>
			</ng-container>
		}

		<ng-container matColumnDef="expand">
			<th mat-header-cell *matHeaderCellDef aria-label="row actions"></th>
			<td mat-cell class="header-chevron" *matCellDef="let element; let row">
				<div
					mat-icon-button
					type="button"
					aria-label="expand row"
					(click)="toggleDetail(element); $event.stopPropagation()"
					id="chevron_{{ onFindIndex(row) }}"
				>
					@if (expandedElement() !== element) {
						<mat-icon svgIcon="chevron_down" class="ob-icon iconsize"></mat-icon>
					}
					@if (expandedElement() === element) {
						<mat-icon svgIcon="chevron_up" class="ob-icon iconsize"></mat-icon>
					}
				</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="expandedDetail">
			<td mat-cell *matCellDef="let element; let row" [attr.colspan]="columnsToDisplayWithExpand.length">
				<div class="element-detail">
					<div class="expand-container" [class.expanded]="expandedElement() === element">
						<div class="expand-container-content">
							<div class="font-weight-600 element-detail-row">{{ "i18n.property.description" | translate }}</div>
							@if (element && element.description) {
								<div name="description">
									{{ element!.description | fallback: currentLanguage! }}
								</div>
							}
							<div class="font-weight-600 element-detail-row">{{ "i18n.property.valid_from" | translate }}</div>
							@if (element && element.validFrom) {
								<div name="validFrom">
									{{ getFormattedDate(element!.validFrom) }}
								</div>
							}
							<div class="font-weight-600 element-detail-row">{{ "i18n.property.valid_to" | translate }}</div>
							@if (element && element.validTo) {
								<div name="validTo">
									{{ getFormattedDate(element!.validTo) }}
								</div>
							}
							@if (element.id) {
								<div>
									<div class="font-weight-600 element-detail-row">{{ "i18n.title.annotations" | translate }}</div>
									<app-edit-table-annotation
										class="element-detail-row"
										(reloadEntriesEvent)="reloadEntries()"
										[conceptId]="conceptId"
										[codelistEntryId]="element.id"
										[annotations]="element.annotations ?? []"
									></app-edit-table-annotation>
									<br />
								</div>
							}
						</div>
					</div>
				</div>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
		<tr mat-row *matRowDef="let row; columns: columnsToDisplayWithExpand"></tr>
		<tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
	</table>

	<div class="table-info-box">
		@if (!canCreateCodeValues()) {
			<ob-alert type="info">{{ "i18n.codelist.createcodelistfirst" | translate }}</ob-alert>
		}
		@if (conceptId) {
			<app-infobox-no-content [datasource]="dataSource.data"></app-infobox-no-content>
		}
	</div>
</div>
